import * as React from "react";
import TextCta, { TextCtaProps } from "~/components/text-cta/text-cta";

export interface ITextCtaViewProps {
    contextModel: TextCtaProps;
}

class TextCtaView extends React.PureComponent<ITextCtaViewProps> {
    public render() {
        return <TextCta {...this.props.contextModel} />;
    }
}

export default TextCtaView;
